import { PaginaTermoNotificacao } from "@/contexts/fiscalizacao/termoNotificacao/model/PaginaTermoNotificacao";
import { ParecerTermoNotificacao } from "@/contexts/fiscalizacao/termoNotificacao/model/ParecerTermoNotificacao";
import { TermoNotificacao } from "@/contexts/fiscalizacao/termoNotificacao/model/TermoNotificacao";
import { api } from "@/shared/api/api";
import { getBlob } from "@/shared/api/getBlob";

export interface ListarTermosNotificacaoParams {
  page: number;
  estabelecimentoId: number;
  dataCadastro?: string;
  numero?: string;
  status?: string;
}

export const createTermoNotificacaoApi = (accessToken?: string) => {
  const headers = { Authorization: `Bearer ${accessToken}` };

  const submit = async (item: Omit<TermoNotificacao, "id">) => {
    const { data } = await api.post<TermoNotificacao>(
      "/termos-notificacao",
      item,
      { headers }
    );
    return data;
  };

  const cancelar = async (id: number, motivo: string) => {
    await api.patch(
      `/termos-notificacao/${id}/cancelar`,
      { motivo },
      { headers }
    );
  };

  const getById = async (id: number) => {
    const { data } = await api.get<TermoNotificacao>(
      `/termos-notificacao/${id}`,
      { headers }
    );
    return data;
  };

  const list = async (params: ListarTermosNotificacaoParams) => {
    const { data } = await api.get<PaginaTermoNotificacao>(
      `/termos-notificacao`,
      {
        headers,
        params: {
          ...params,
          size: 20,
          page: params.page - 1,
        },
      }
    );
    return data;
  };

  const submitSaneamento = async (termoId: number, formData: FormData) => {
    const { data } = await api.post<TermoNotificacao>(
      `/termos-notificacao/${termoId}/saneamentos`,
      formData,
      {
        headers: { ...headers, "Content-Type": "multipart/form-data" },
      }
    );
    return data;
  };

  const submitParecer = async (
    termoId: number,
    saneamentoId: number,
    parecer: ParecerTermoNotificacao
  ) => {
    const { data } = await api.patch<TermoNotificacao>(
      `/termos-notificacao/${termoId}/saneamentos/${saneamentoId}/parecer`,
      parecer,
      { headers }
    );
    return data;
  };

  const getSaneamentos = async (termoId: number) => {
    const { data } = await api.get<TermoNotificacao>(
      `/termos-notificacao/${termoId}/saneamentos`,
      { headers }
    );
    return data;
  };

  const getAnexo = (nomeUpload: string) =>
    getBlob(`/termos-notificacao/anexo/${nomeUpload}`, { headers });

  return {
    submit,
    cancelar,
    getById,
    list,
    submitSaneamento,
    submitParecer,
    getSaneamentos,
    getAnexo,
  };
};

// Endpoint público (sem token): usado na página de impressão aberta pelo QR code.
export const getTermoNotificacaoPublico = async (codigoVerificador: string) => {
  const { data } = await api.get<TermoNotificacao>(
    `/termos-notificacao/publico/${codigoVerificador}/pdf`
  );
  return data;
};
